<div class="pinned-messages-wrapper">
  <h4 class="text-color-primary">{{'WEBCLIENT.CHATROOM.PINNED_MESSAGE.LIST_TITLE' | translate}}</h4>

  <div class="pinned-messages-list">
    <div class="pinned-message-row clickable" *ngFor="let row of rows" (click)="onMessageClick(row.message)">
      <tn-message-parent [message]="row.message" [isSentByMe]="row.message.isSentByMe"></tn-message-parent>

      <div class="pinned-message-meta text-color-secondary">
        <span *ngIf="row.pinnedByContact && row.pinnedByContact.name">
          {{'WEBCLIENT.CHATROOM.PINNED_MESSAGE.PINNED_BY' | translate: {'USER': row.pinnedByContact.name} }}
        </span>
        <span *ngIf="row.message.pinned_at"> &middot; {{ row.message.pinned_at | tnDate: 'MESSAGE_INFO_DATE' }}</span>
      </div>

      <div class="pinned-message-unpin clickable" *ngIf="canPin" (click)="onUnpin(row.message, $event)">
        <i class="fa fa-fw fa-times"></i>
      </div>
    </div>

    <div class="empty-state text-color-secondary" *ngIf="rows.length === 0">
      {{'WEBCLIENT.CHATROOM.PINNED_MESSAGE.EMPTY' | translate}}
    </div>
  </div>
</div>
